export default __webpack_public_path__ + "static/media/effect-16.4e1fc30f.mp3";